import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Reporte_x_pais, Reporte_x_pais_Grafico } from 'src/app/models/QR';
import { QrService } from 'src/app/service/qr.service';

@Component({
  selector: 'app-reporte-detalle-pais',
  templateUrl: './reporte-detalle-pais.component.html',
  styleUrls: ['./reporte-detalle-pais.component.css']
})
export class ReporteDetallePaisComponent {
  id:any = 0;
  pais:any = '';
  List_Reporte_Pais: Reporte_x_pais[]= [];
  List_Reporte_x_pais_Grafico:Reporte_x_pais_Grafico[] = [];
  numeroVisitas: number = 0;

  constructor(private route: ActivatedRoute,
              private modulesService: QrService){
    
  }

   // options
 gradient: boolean = true;
 showLegend: boolean = true;
 showLabels: boolean = true;
 isDoughnut: boolean = false;
 legendPosition: string = 'below';

 onSelect(data:any): void {
  console.log('Item clicked', JSON.parse(JSON.stringify(data)));
}

onActivate(data:any): void {
  console.log('Activate', JSON.parse(JSON.stringify(data)));
}

onDeactivate(data:any): void {
  console.log('Deactivate', JSON.parse(JSON.stringify(data)));
}

  ngOnInit(): void {

    this.id = this.route.snapshot.queryParamMap.get('id');
    this.pais = this.route.snapshot.queryParamMap.get('pais');

    this.cargaDetalleLista(this.id,this.pais);
    this.cargaGraficoLista(this.id,this.pais);
  }

  cargaDetalleLista(id:number,pais:string){
  
    this.modulesService.Lista_Reporte_x_Pais(pais,id).subscribe(
      data => {
        this.List_Reporte_Pais= data;
        data.forEach(element => {
     
          this.numeroVisitas += element.cantidad ? element.cantidad : 0;
        
        });
      }
    )
  }

  cargaListaCombo(id:number){
   /* this.modulesService.Lista_Reporte_x_Pais_combo(id).subscribe(
      date=> {
        this.List_Reporte_Pais = date;
      }
    )*/
  }

  cargaGraficoLista(id:number,pais:string){
    this.modulesService.Lista_Reporte_x_Pais_Grafico(pais,id).subscribe(
      data => {
        this.List_Reporte_x_pais_Grafico= data;
      }
    )
  }
}
